/**
 * Идентификаторы тем (ФТ-8.3: централизованная смена гаммы; минимум две темы).
 */
export const THEME_IDS = {
  DEFAULT: "default",
  ADMIN: "admin",
} as const;

/** Идентификатор темы. */
export type ThemeId = (typeof THEME_IDS)[keyof typeof THEME_IDS];

/** Атрибут корня темы на DOM-элементе. */
export const THEME_ROOT_ATTR = "data-potok-theme" as const;

/** Список доступных тем. */
export const THEME_ID_LIST: readonly ThemeId[] = Object.values(THEME_IDS);
